import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import { UserContextProvider } from './contexts/UserContext';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { ProductsContextProvider } from './contexts/ProductsContext';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <GoogleOAuthProvider clientId="283221269197-rdpd3ahip21uo0a058sp72erp3k86e85.apps.googleusercontent.com">
    <React.StrictMode>
      <ProductsContextProvider>
        <UserContextProvider>
            <BrowserRouter>
              <App />
            </BrowserRouter>
        </UserContextProvider>
      </ProductsContextProvider>
    </React.StrictMode>
  </GoogleOAuthProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
